import { Text } from 'ui/components/primitives';

import { getProgress } from './Progress.helpers';
import { Progress } from './Progress.styles';

import type { ProgressBarProps } from './Progress.d';

const ProgressBarBase = ({
  color,
  customInfo,
  customLabel,
  maxValue,
  showInfo,
  showLabel,
  size,
  value,
  ...rest
}: ProgressBarProps) => {
  const { current, isCompleted } = getProgress(value, maxValue);
  const labelValue = !isCompleted ? `${current}%` : '100%';

  return (
    <Progress.Component
      aria-valuemax={maxValue}
      aria-valuemin={0}
      aria-valuenow={value}
      data-testid="progressbar"
      role="progressbar"
      {...rest}
    >
      <Progress.Range
        data-color={color}
        data-label={customLabel || labelValue}
        data-showlabel={showLabel}
        data-size={size}
        max={maxValue}
        value={value}
      />

      {showInfo && (
        <Progress.Info>
          <Text variant="auxiliar-small">{customInfo || `${value} de ${maxValue}`}</Text>
        </Progress.Info>
      )}
    </Progress.Component>
  );
};

export default ProgressBarBase;
